import Api from './Api';

const END_POINT = 'variants';

export default {
    get_all(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}`, request);
    },
    store(variant) {
        return Api.post(`${END_POINT}`, variant);
    },
    update(variant) {
        return Api.patch(`${END_POINT}/${variant.id}`, variant);
    },
    change_status(variant) {
        return Api.patch(`${END_POINT}/${variant.id}/change-status`, variant);
    },
    get_Options(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}/options`, request);
    },
}